import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.03625 12.5285L12.9505 1.96816C13.1635 1.3928 12.6032 0.833214 12.0286 1.04629L1.46467 4.96336C0.803934 5.20872 0.855588 6.16001 1.53928 6.33147L6.44209 7.56327L7.66671 12.4532C7.83889 13.1376 8.7909 13.1899 9.03625 12.5285V12.5285Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.7855 1.20911L6.4436 7.56539",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSendMessage;
